import React from 'react';
import useAuth from '../hooks/useAuth';
import LogoutButton from '../components/LogoutButton';

const AuthDemo = () => {
  const { isAuthenticated, userType, isLoading, getToken } = useAuth();

  if (isLoading) {
    return <div>Chargement...</div>;
  }

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h1>Démo du système d'authentification</h1>
      
      <div style={{ 
        background: isAuthenticated ? '#d4edda' : '#f8d7da', 
        padding: '15px', 
        borderRadius: '5px', 
        marginBottom: '20px',
        border: `1px solid ${isAuthenticated ? '#c3e6cb' : '#f5c6cb'}`
      }}>
        <h3>Statut d'authentification</h3>
        <p><strong>Connecté :</strong> {isAuthenticated ? '✅ Oui' : '❌ Non'}</p>
        <p><strong>Type d'utilisateur :</strong> {userType || 'Aucun'}</p>
        <p><strong>Token :</strong> {getToken() ? '✅ Présent' : '❌ Absent'}</p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Test des tokens</h3>
        <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
          <button 
            onClick={() => localStorage.setItem('expert_token', 'demo-expert-token')}
            style={{ padding: '8px 16px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px' }}
          >
            Simuler connexion Expert
          </button>
          <button 
            onClick={() => localStorage.setItem('client_token', 'demo-client-token')}
            style={{ padding: '8px 16px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px' }}
          >
            Simuler connexion Client
          </button>
          <button 
            onClick={() => {
              localStorage.removeItem('expert_token');
              localStorage.removeItem('client_token');
              window.location.reload();
            }}
            style={{ padding: '8px 16px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '4px' }}
          >
            Vider les tokens
          </button>
        </div>
      </div>

      {isAuthenticated && (
        <div style={{ 
          background: '#fff3cd', 
          padding: '15px', 
          borderRadius: '5px', 
          border: '1px solid #ffeaa7',
          marginBottom: '20px'
        }}>
          <h3>Actions disponibles</h3>
          <p>Vous êtes connecté en tant que <strong>{userType}</strong></p>
          
          <div style={{ marginTop: '15px' }}>
            <LogoutButton />
          </div>
        </div>
      )}
    </div>
  );
};

export default AuthDemo;